import React from "react";
import format from "date-fns/format";
import classnames from "classnames";

import "./Patients.css";

import {
  PATIENT_ALLERGIES,
  PATIENT_MEDICAL_CONDITION,
  PATIENT_PREVIOUS_SURGERY,
  PATIENT_FAMILIY_MEDICAL_HISTORY,
  PATIENT_PHARMACY,
  PATIENT_MEDICATIONS,
} from "../../../../constants";

import StackGrid from "react-stack-grid";

const PatientDetails = ({ patient }) => {
  return (
    <>
      <div className="mx-auto content-center text-center row patient-details-main">
        <span className="col-md-4 border-right">
          <p className="title">Height</p>
          <p className="detail">{patient?.height || "-"}</p>
        </span>
        <span className="col-md-4 border-right">
          <p className="title">Weight</p>
          <p className="detail">{patient?.weight || "-"} lbs</p>
        </span>
        <span className="col-md-4">
          <p className="title">BMI</p>
          <p className="detail">{patient?.bmi || "-"}</p>
        </span>
      </div>
      <div
        className="pl-4 py-4"
        style={{
          color: "#1E1C61",
        }}
      >
        <StackGrid
          columnWidth={window.innerWidth <= 768 ? "100%" : "33.33%"}
          gutterWidth={5}
          gutterHeight={10}
          monitorImagesLoaded={true}
          duration={0}
          style={{
            zIndex: -1,
          }}
        >
          <div className="patient-detail d-flex">
            <img
              src={PATIENT_ALLERGIES}
              width={133}
              height={124}
              alt="alergies"
            />
            <span className="pt-2 pl-4">
              <p className="title">Allergies : </p>
              {patient?.allergy?.map(allergy => (
                <p className="detail mb-1 mt-1">{allergy}</p>
              ))}
              {(!patient?.allergy || patient?.allergy?.length === 0) && (
                <p className="detail"> - </p>
              )}
            </span>
          </div>
          <div className="patient-detail d-flex">
            <img
              src={PATIENT_MEDICAL_CONDITION}
              width={119}
              height={128}
              alt="medical_condition"
            />
            <span className="pt-2 pl-4">
              <p className="title">Medical Condition : </p>
              <p className="detail">
                {patient?.medical_condition?.map(medical => (
                  <p className="detail mb-1 mt-1">{medical}</p>
                ))}
                {(!patient?.medical_condition ||
                  patient?.medical_condition?.length === 0) && (
                  <p className="detail"> - </p>
                )}
              </p>
            </span>
          </div>
          <div className="patient-detail d-flex">
            <img
              src={PATIENT_PREVIOUS_SURGERY}
              width={137}
              height={116}
              alt="previous_surgery"
            />
            <span className="pt-2 pl-4">
              <p className="title">Previous Surgery : </p>
              {patient?.patient_previous_surgeries?.length > 0 ? (
                patient?.patient_previous_surgeries?.map(surgery => (
                  <p className="detail mb-1 mt-1">
                    {surgery?.surgery_name} -{" "}
                    {format(new Date(surgery?.surgery_date), "dd MMMM, yyyy")}
                  </p>
                ))
              ) : (
                <p>-</p>
              )}
            </span>
          </div>
          <div className="patient-detail d-flex">
            <img
              src={PATIENT_FAMILIY_MEDICAL_HISTORY}
              width={141}
              height={124}
              alt="medical_history"
            />
            <span className="pt-2 pl-4">
              <p className="title">Family Medical History : </p>
              <p className="detail">
                {patient?.family_medical_history?.map(family => (
                  <p className="detail mb-1 mt-1">{family}</p>
                ))}
                {(!patient?.family_medical_history ||
                  patient?.family_medical_history?.length === 0) && (
                  <p className="detail"> - </p>
                )}
              </p>
            </span>
          </div>
          <div className="patient-detail d-flex">
            <img
              src={PATIENT_PHARMACY}
              width={137}
              height={136}
              alt="pharmacy"
            />
            <span className="pt-2 pl-4">
              <p className="title">Pharmacy : </p>
              <p className="detail">
                {patient?.pharmacy_details?.map(pharmacy => (
                  <p className="detail mb-1 mt-1">{pharmacy}</p>
                ))}
                {(!patient?.pharmacy_details ||
                  patient?.pharmacy_details?.length === 0) && (
                  <p className="detail"> - </p>
                )}
              </p>
            </span>
          </div>
          <div
            className={classnames(
              "patient-detail",
              (!patient || patient?.patient_medication_details?.length === 0) &&
                "d-flex"
            )}
          >
            <img
              src={PATIENT_MEDICATIONS}
              alt="medications"
              width={138}
              height={130}
              className={classnames(
                "mr-1",
                patient?.patient_medication_details?.length > 0 && "float-left"
              )}
            />
            <span className="pt-2">
              <p className="title">Medications : </p>
              {patient?.patient_medication_details?.map((medication, i) => (
                <>
                  <p className="detail my-1 pl-3">
                    <span className="medication">Name</span>
                    <span>
                      {" -"} {medication?.medicine_name}
                    </span>
                  </p>

                  <p className="detail my-1 pl-3">
                    <span className="medication">Dosage</span>
                    <span>
                      {" -"} {medication?.dosage}
                    </span>
                  </p>
                  <p className="detail my-1 pl-3 pb-1">
                    <span className="medication">Instructions</span>
                    <span>
                      {" -"} {medication?.instruction}
                    </span>
                  </p>
                </>
              ))}
              {(!patient ||
                patient?.patient_medication_details?.length === 0) && (
                <p className="detail"> - </p>
              )}
            </span>
          </div>
        </StackGrid>
      </div>
    </>
  );
};

export default PatientDetails;
